
export default {
  namespaced: true,
  state: () => ({
    menuItems: ['search', 'messenger', 'policies', 'subjects'],
    showKeywordsUnCensored: false,
  }),
  mutations: {
    setMenuItems (state, menuItems) {
      state.menuItems = menuItems
    },
    setShowKeywordsUnCensored(state, showKeywordsUnCensored) {
      state.showKeywordsUnCensored = showKeywordsUnCensored
    }
  },
}